import React from "react";
import { backButton } from "@telegram-apps/sdk-react";
import { useNavigate } from "react-router";

interface UseBackButtonProps {
  onClick?: () => void;
  // screens opened straight from a deep link have no history behind them, so they leave the back
  // button off and let Telegram show its close button instead
  enabled?: boolean;
}

export default function useBackButton ({ onClick, enabled = true }: UseBackButtonProps = {}): void {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    if (backButton.mount.isAvailable()) {
      backButton.mount();
    }

    backButton.onClick(() => {
      if (onClick) {
        onClick();
      } else {
        navigate(-1);
      }
    });

    if (backButton.show.isAvailable()) {
      backButton.show();
    }

    return () => {
      backButton.hide();
      backButton.unmount();
    }
  }, [navigate, onClick, enabled]);
}
